var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed z-999 right-5 top-60"},[_c('el-button',{staticClass:"w-14 h-14 btn-primary",attrs:{"circle":"","type":"primary","size":"large"},on:{"click":function($event){return _vm.$router.push('/product/myCart')}}},[_c('i',{staticClass:"el-icon-shopping-cart-full text-3xl"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }